// 计算保费
let mockBaseUrl = 'http://rap2api.taobao.org/app/mock/228718'
export default {
  // 计算保费
  '/sale/product/getDetail': mockBaseUrl + '/calculatePremium',
  '/sale/product/getMainRiskLst': mockBaseUrl + '/mainRiskList',
  '/sale/insure/trial': mockBaseUrl + '/mainRiskList',
  '/sale/insure/orderDetail': mockBaseUrl + '/mainRiskList'
}
